module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.2.1-rc.8-97.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.2.1-rc.8.md
// module id = 514
// module chunks = 314